import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;

  input {
    margin-left: 1rem;
    width: 16rem;
  }
`;
